import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=21391b78"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=21391b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports